import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/layout/layout";
import { ScrollToTop } from "./components/scroll-to-top";
import { ProtectedRoute } from "./components/auth/protected-route";
import { Home } from "./pages/home";
import { Contact } from "./pages/contact";
import { ServiceDetail } from "./pages/service-detail";
import { About } from "./pages/about";
import { Partners } from "./pages/partners";
import { Privacy } from "./pages/privacy";
import { CookiePolicy } from "./pages/cookie";
import { LegalNotes } from "./pages/legal-notes";
import { CorporatePolicy } from "./pages/corporate-policy";
import { GenderEquality } from "./pages/gender-equality";
import { Whistleblowing } from "./pages/whistleblowing";
import { Farmacovigilanza } from "./pages/farmacovigilanza";
import { MOG } from "./pages/mog";
import { CodiceEtico } from "./pages/codice-etico";
import { Login } from "./pages/login";
import { RestrictedArea } from "./pages/restricted-area";
import { DocsManagement } from "./pages/docs-management";
import { Permissions } from "./pages/permissions";
import { CommercialArea } from "./pages/commercial-area";
import { CommercialLogin } from "./pages/commercial-login";
import { DeliveryForm } from "./pages/delivery-form";
import { AccessibilityStatement } from "./pages/accessibility-statement";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Commercial Area Routes - Independent from Main Layout */}
        <Route path="/area-commerciale/login" element={<CommercialLogin />} />
        
        <Route element={<ProtectedRoute allowedRoles={['admin', 'commercial']} loginPath="/area-commerciale/login" />}>
          <Route path="/area-commerciale" element={<CommercialArea />} />
          <Route path="/area-commerciale/modulo-consegne" element={<DeliveryForm />} />
        </Route>

        {/* Public Routes with Layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="login" element={<Login />} />
          
          <Route element={<ProtectedRoute allowedRoles={['admin', 'employee']} loginPath="/login" />}>
            <Route path="area-riservata" element={<RestrictedArea />} />
            <Route path="area-riservata/gestione-documenti" element={<DocsManagement />} />
            <Route path="area-riservata/permessi" element={<Permissions />} />
          </Route>

          <Route path="contatti" element={<Contact />} />
          <Route path="servizi" element={<Navigate to="/" replace />} />
          <Route path="servizi/:slug" element={<ServiceDetail />} />
          <Route path="chi-siamo" element={<About />} />
          <Route path="partner" element={<Partners />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="cookie" element={<CookiePolicy />} />
          <Route path="note-legali" element={<LegalNotes />} />
          <Route path="politica-aziendale" element={<CorporatePolicy />} />
          <Route path="parita-di-genere" element={<GenderEquality />} />
          <Route path="whistleblowing" element={<Whistleblowing />} />
          <Route path="farmacovigilanza" element={<Farmacovigilanza />} />
          <Route path="mog" element={<MOG />} />
          <Route path="codice-etico" element={<CodiceEtico />} />
          <Route path="dichiarazione-accessibilita" element={<AccessibilityStatement />} />
          <Route path="risorse" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
